const contactBankRu = {
  'contactBank': 'Связь с банком',
};

export default contactBankRu;
